// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/inventory/-components";
import { Loading } from "@/layouts/loading";
import { pharmacyClient } from "@/connect";
import { Level, PharmacySize, StockPointType } from "@/gen/auth/common_pb";
import { CategoryWiseDistribution, ExpiryRiskTimeline, HealthScore, InventoryValueTrend, StockStatusDistribution, TopSupplier } from "@/gen/inventory/common_pb";
import { InventoryOverviewSchema, StockStatusSplit } from "./-data/model";
import { PricingPendingAcceptance } from "@/gen/medical_master/common_pb";
import { ListPurchaseOrdersResponse } from "@/gen/purchase_order/list_purchase_orders_pb";
import { ListPurchaseInvoicesResponse } from "@/gen/purchase_invoice/list_purchase_invoices_pb";
import { ListPurchaseRequestsResponse } from "@/gen/purchase_request/list_purchase_requests_pb";
import { TransferHistoryResponse } from "@/gen/inventory/transfer_history_pb";

type Props = {
    inventory_overview: InventoryOverviewSchema;
    top_suppliers: TopSupplier[];
    expiry_timeline: ExpiryRiskTimeline[];
    stock_status_split: StockStatusDistribution[];
    health_scores: HealthScore;
    non_medical_category_distribution: CategoryWiseDistribution[];
    inventory_trend: InventoryValueTrend[];
    purchase_orders?: ListPurchaseOrdersResponse;
    purchase_invoices?: ListPurchaseInvoicesResponse;
    purchase_requests?: ListPurchaseRequestsResponse;
    inventory_transfers?: TransferHistoryResponse;
}
export const Route = createFileRoute("/(pharma)/_layout/inventory/")({
    component: Component,
    loader: async (): Promise<Props> => {
        const inventoryOverview = await pharmacyClient.inventoryOverview({});

        const pharmacySize = localStorage.getItem('pharmacySize')
        const stockPointType = localStorage.getItem('stockPointType')

        if (pharmacySize === PharmacySize.SIZE_SMALL.toString()) {
            const inventoryOverviewData = inventoryOverview.branchLevelView
            let purchaseOrders, purchaseInvoices, purchaseRequests, inventoryTransfers;

            if (stockPointType === StockPointType.RECEIVING.toString()) {
                // Fetch all only 2
                purchaseOrders = await pharmacyClient.listPurchaseOrders({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseInvoices = await pharmacyClient.listPurchaseInvoices({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseRequests = await pharmacyClient.listPurchaseRequests({
                    page: 1,
                    pageSize: 2,
                });
                inventoryTransfers = await pharmacyClient.transferHistory({
                    pageNumber: 1,
                    pageSize: 2,
                })
            } else {
                purchaseRequests = await pharmacyClient.listPurchaseRequests({
                    page: 1,
                    pageSize: 2,
                });
                inventoryTransfers = await pharmacyClient.transferHistory({
                    pageNumber: 1,
                    pageSize: 2,
                })
            }

            return {
                inventory_overview: {
                    total_inventory_count: inventoryOverviewData?.totalItems!,
                    total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                    out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                    expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                },
                top_suppliers: inventoryOverviewData?.topSuppliers!,
                expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                health_scores: inventoryOverviewData?.healthScore!,
                non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                inventory_trend: inventoryOverviewData?.inventoryValueTrends!,
                purchase_orders: purchaseOrders,
                purchase_invoices: purchaseInvoices,
                purchase_requests: purchaseRequests,
                inventory_transfers: inventoryTransfers                
            }
        } else {
            const level = localStorage.getItem('level')
            let purchaseOrders, purchaseInvoices, purchaseRequests, inventoryTransfers;

            if (stockPointType === StockPointType.RECEIVING.toString()) {
                // Fetch all only 2
                purchaseOrders = await pharmacyClient.listPurchaseOrders({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseInvoices = await pharmacyClient.listPurchaseInvoices({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseRequests = await pharmacyClient.listPurchaseRequests({
                    page: 1,
                    pageSize: 2,
                });
                inventoryTransfers = await pharmacyClient.transferHistory({
                    pageNumber: 1,
                    pageSize: 2,
                })
            } else {
                purchaseRequests = await pharmacyClient.listPurchaseRequests({
                    page: 1,
                    pageSize: 2,
                });
                inventoryTransfers = await pharmacyClient.transferHistory({
                    pageNumber: 1,
                    pageSize: 2,
                })
            }
            if (level === Level.BRANCH.toString()) {
                const inventoryOverviewData = inventoryOverview.branchLevelView
                return {
                    inventory_overview: {
                        total_inventory_count: inventoryOverviewData?.totalItems!,
                        total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                        out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                        expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                    },
                    top_suppliers: inventoryOverviewData?.topSuppliers!,
                    expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                    stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                    health_scores: inventoryOverviewData?.healthScore!,
                    non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                    inventory_trend: inventoryOverviewData?.inventoryValueTrends!,
                    purchase_orders: purchaseOrders,
                    purchase_invoices: purchaseInvoices,
                    purchase_requests: purchaseRequests,
                    inventory_transfers: inventoryTransfers
                }
            } else if (level === Level.STOCK_POINT.toString()) {
                const inventoryOverviewData = inventoryOverview.stockPointLevelView

                return {
                    inventory_overview: {
                        total_inventory_count: inventoryOverviewData?.totalItems!,
                        total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                        out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                        expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                    },                    
                    top_suppliers: inventoryOverviewData?.topSuppliers!,
                    expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                    stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                    health_scores: inventoryOverviewData?.healthScore!,
                    non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                    inventory_trend: inventoryOverviewData?.inventoryValueTrends!,
                    purchase_orders: purchaseOrders,
                    purchase_invoices: purchaseInvoices,
                    purchase_requests: purchaseRequests,
                    inventory_transfers: inventoryTransfers
                }
            } else {
                throw new Error("Invalid pharmacy size or level");
            }
        }
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});